export const LinkContainer = ({linkUrl, imageUrl, alt}) => {
    return(
        <a 
            href={linkUrl} 
            target={"_blank"} 
            rel="noopener noreferrer"
            className="group relative p-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl hover:bg-white/20 transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 shadow-lg hover:shadow-xl"
        >
            <img 
                src={imageUrl} 
                alt={alt} 
                width="28" 
                height="28" 
                className="transition-all duration-300 group-hover:brightness-110" 
            />
            <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-blue-400/20 to-indigo-400/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </a>
    )
}

const SocialMedia = ({socialMedias}) => {
    return(
        <div className="flex gap-4 items-center">
            <span className="text-sm font-medium text-slate-600 hidden sm:block">Connect with me:</span>
            <div className="flex gap-3">
                {socialMedias?.map(({iconUrl, name, linkUrl}, index) => (
                    <LinkContainer 
                        key={index} 
                        linkUrl={linkUrl} 
                        alt={name} 
                        imageUrl={iconUrl} 
                    />
                ))}
            </div>
        </div>
    )
}
export default SocialMedia;